import { get, isEmpty } from 'lodash';

export interface InfoProps {
    salutation: string | undefined;
    givname: string | undefined;
    surname: string | undefined;
    fullname: string | undefined;
    mobileNum: string | undefined;
    emailId: string | undefined;
    isAvivaCustomer: string | undefined;
    nric?: string;
    dob?: string;
    income?:string;
}

export class PersonalInfo {
      salutation: string | undefined;
      firstName: string | undefined;
      lastName: string | undefined;
      fullName: string | undefined;
      mobileNum: string | undefined;
      emailId: string | undefined;
      nric?: string;
      dateOfBirth?: string;
      nationality: string;
      residentialStatus: string;
      gender: string;
      stayInTouch?:  string;
      address: {}
      // address: {
      //   block: string;
      //   unitNo: string;
      //   street: string;
      //   postal: string;
      //   building: string;
      // };
    

  constructor(initial: any) {
    this.salutation = get(initial, 'salutation', undefined);
    const firstName = get(initial, 'firstName', undefined);
    this.firstName = isEmpty(firstName) ? undefined : firstName;
    const lastName = get(initial, 'lastName', undefined);
    this.lastName = isEmpty(lastName) ? undefined : lastName;
    this.fullName = get(initial, 'fullName', undefined);
    const mobileNum = get(initial, 'mobileNum', undefined);
    this.mobileNum =  isEmpty(mobileNum) ? undefined : mobileNum;
    const emailId = get(initial, 'emailId', undefined);
    this.emailId = isEmpty(emailId) ? undefined : emailId;
    this.dateOfBirth = get(initial, 'dateOfBirth', undefined);
    this.nric = get(initial, 'nric', undefined);
    this.nationality = get(initial, 'nationality', undefined);
    this.residentialStatus = get(initial, 'residentialStatus', undefined);
    this.gender = get(initial, 'gender', undefined);
    this.stayInTouch = get(initial, 'stayInTouch', undefined);
    const address = get(initial, 'address', undefined);
    this.address = isEmpty(address) ? {} : address;

  }
}